import { toPoints } from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Program Id",
    accessor: "program_id",
    className: "participant-account-summary__cell--id",
  },
  {
    Header: "Program Name",
    accessor: "program_name",
    className: "participant-account-summary__cell--program",
  },
  {
    Header: "Employee Number",
    accessor: "employee_number",
    className: "participant-account-summary__cell--meta",
  },
  // {
  //   Header: "Org Id",
  //   accessor: "recipient_organization_uid",
  // },
  {
    Header: "First Name",
    accessor: "recipient_first_name",
    className: "participant-account-summary__cell--name",
  },
  {
    Header: "Last Name",
    accessor: "recipient_last_name",
    className: "participant-account-summary__cell--name",
  },
  {
    Header: "Email",
    accessor: "recipient_email",
    className: "participant-account-summary__cell--email",
  },
  {
    Header: "Account Created",
    accessor: "created",
    className: "participant-account-summary__cell--date",
    Cell: ({ value }) => {
      let date = new Date(value).toLocaleDateString("en-US", {});
      return <span>{date}</span>;
    },
  },
  {
    Header: "Amount Awarded",
    accessor: "points_awarded",
    className: "participant-account-summary__cell--numeric",
    Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  },
  {
    Header: "Amount Redeemed",
    accessor: "points_redeemed",
    className: "participant-account-summary__cell--numeric",
    Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  },
  // {
  //   Header: "Amount Expired",
  //   accessor: "points_expired",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Amount Reclaimed",
  //   accessor: "points_reclaimed",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Award Credit Reclaimed",
  //   accessor: "award_credit_points_reclaimed",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  {
    Header: "Current Balance",
    accessor: "points_balance",
    className: "participant-account-summary__cell--numeric",
    Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  },
  // {
  //   Header: "Anniversary",
  //   accessor: "anniversary",
  // },
  // {
  //   Header: "Birthday",
  //   accessor: "birth",
  // },
];

export const PEER2PEER_COLUMNS = [{
  Header: "Peer Points Allocated",
  accessor: "peer_rewards_earned",
  className: "participant-account-summary__cell--numeric",
  Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
},
{
  Header: "Peer Points Given",
  accessor: "peer_rewards_given",
  className: "participant-account-summary__cell--numeric",
  Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
},
{
  Header: "Peer Points Balance",
  accessor: "peer_balance",
  className: "participant-account-summary__cell--numeric",
  Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
}]
